import Quill from "quill";

const Parchment = Quill.import("parchment");

type Style = new (attributeName: string, keyName: string, options: any) => any;

const StyleAttributor: Style = Parchment.Attributor.Style;

const levels = [1, 2, 3, 4, 5, 6, 7, 8, 9];
const multiplier = 15;

// The solution is taken from https://github.com/quilljs/quill/issues/1930
class IndentAttributor extends StyleAttributor {
    add(node: HTMLElement, value: string) {
        return super.add(node, `${Number(value) * multiplier}px`);
    }

    value(node: HTMLElement) {
        return Number.parseFloat(super.value(node)) / multiplier || undefined;
    }
}

export const IndentStyle = new IndentAttributor("indent", "margin-left", {
    scope: Parchment.Scope.BLOCK,
    whitelist: levels.map((value) => `${value * multiplier}px`),
});
